/** The import run "Diagnose" tab — a thin adapter over the shared AI chat
 *  panel (features/ai-diag). All chat/thread/polling behavior lives there;
 *  this file only says how to start an import diagnosis and how to recognize
 *  this run's tasks in the bgtasks listing. */
import { useMemo } from 'react';

import * as importRunsApi from '@/api/importRuns';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ runId }: { runId: string }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: importRunsApi.diagnoseLaunchContext,
      start: (body) => importRunsApi.startDiagnose(runId, body),
      taskType: 'import_diagnose',
      subjectNoun: 'import run',
      subjectTitle: `Import run ${runId}`,
      questionPlaceholder: 'e.g. "Why did this booking not import?"',
      // The task label carries the run UUID — narrows the listing server-side.
      labelContains: runId,
      matchesSubject: (params) =>
        (params as { import_run_id?: string } | null)?.import_run_id === runId,
    }),
    [runId],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        "The AI sees this run's metadata and processing report, the input " +
        'document, its logs, the initiating webhook, tenant config and the ' +
        "booking system's current records — nothing else."
      }
    />
  );
}
